import { IDonHangSearchRequest } from "../../../model/request/don-hang/IDonHangSearchRequest";
import { IDonHangViewModel } from "../../../model/respone/don-hang/IDonHangViewModel";
import { ISendEmailRequest } from "../../../model/request/don-hang/SendEmailRequest";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDonHangActionTypeDefine = {
    LOAD_START: {} as IDonHangSearchRequest,
    LOAD_SUCCESS: {} as IDonHangViewModel[],
    LOAD_ERROR: "",

    CHANGED_DONHANG_SELECTED_IDS: [] as number[],
    CHANGED_TRANGTHAI_SELECTED_IDS: [] as number[],

    SEND_EMAIL_START: {} as ISendEmailRequest,
    SEND_EMAIL_SUCCESS: {} as any,
    SEND_EMAIL_ERROR: "",
}

export const eDonHangActionTypeIds = generateActionTypeIds(eDonHangActionTypeDefine, "DON_HANG");

export type IDonHangActions = IGenericActionType<typeof eDonHangActionTypeDefine, "DON_HANG">;